// extracted by mini-css-extract-plugin
module.exports = {"header":"MonthErrorTime_header__mceVW","block":"MonthErrorTime_block__2qR7o"};